import {
    CLUSTER_ITEM_RESPONSE,
    CLUSTER_LIST_RESPONSE,
    UNAUTHENTICATED
} from "../../actions/action-types"
import { normalise } from "../../models/entities/cluster"
import { extractEntitiesFromData } from "./entity-reducer-utils"

export default (state = {}, action) => {
    const { type, data, receivedAt } = action
    switch (type) {
        case CLUSTER_ITEM_RESPONSE:
            const { id } = data
            return {
                ...state,
                [id]: {
                    ...normalise(data),
                    articleCount: state[id] && state[id].articleCount,
                    lastUpdatedAt: receivedAt
                }
            }
        case CLUSTER_LIST_RESPONSE:
            const extractedData = extractEntitiesFromData(data, state)
            return Object.keys(extractedData).reduce(
                (newState, clusterId) => ({
                    ...newState,
                    [clusterId]: {
                        ...newState[clusterId],
                        articleCount:
                            newState[clusterId].articleCount ||
                            newState[clusterId].article_ids.length
                    }
                }),
                extractedData
            )
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
